module.exports = __webpack_public_path__ + "img/1716873495362-WhatsApp Image 2024-03-23 at 13.43.43.jpeg.fc6df974.webp";